<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    transition="fade-transition"
    width="400px"
    content-class="ims-standard-dialog"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="title ims-modal-header">
        <span>Influencers Database Selection</span>
        <v-spacer></v-spacer>
        <v-btn icon color="secondary" aria-label="Close" title="Close" @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container class="ims-modal-body">
        <v-row>
          <v-col cols="12">
            <v-alert text dense border="bottom" type="info" class="caption mb-1">
              Please Take Note that based on the selection of Size, Minimum Followers and Date, the execution time could be vary.
              If you are not sure, please leave default values.
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-text-field
              prepend-icon="mdi-book-open-page-variant"
              label="Size"
              placeholder="Number of posts from the sliced database."
              type="number"
              v-model.number="size"
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-account-group"
              label="Minimum Followers"
              placeholder="Minimum followers accounts to be selected."
              type="number"
              v-model.number="minFollowers"
            ></v-text-field>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formattedDate"
                  label="Influencers' posts to date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="postDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="secondary" @click="menu = false">Cancel</v-btn>
                <v-btn text color="secondary" @click="$refs.menu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="ims-modal-actions">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="primary" @click="saveChanges()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>    
</template>
<script>
import moment from 'moment'
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      size: this.$store.state.aiMatchParams.size,
      minFollowers: this.$store.state.aiMatchParams.minFollowers,
      postDate: this.$store.state.aiMatchParams.postDate
    }
  },
  methods: {
    close() {
      this.$emit('input')
    },
    saveChanges() {
      let params = {
        size: this.size,
        minFollowers: this.minFollowers,
        postDate: this.postDate
      }
      this.$store.commit('SET_MATCH_PARAMS', params)
      this.$emit('paramsUpdated')
      this.close()
    }
  },
  computed: {
    formattedDate() {
      return moment(this.postDate).format('DD-MM-YYYY') // for display
    }
  }
}
</script>



// WEBPACK FOOTER //
// SettingsForAIModal.vue?72ce8d99